import {BaseConfig} from "../../infrastructure/config/base-config";
import {ScoresBarWidgetTerms} from "./scores-bar-widget.terms";
import {ScoresBarWidgetRemoteConfig} from "./scores-bar-widget.remote-config";

export class ScoresBarWidgetConfig extends BaseConfig {
  prevDaysAmountToBeLink: Number;
  nextDaysAmountToBeLink: Number;

  static injectables = [ScoresBarWidgetTerms, ScoresBarWidgetRemoteConfig];

  constructor(terms: ScoresBarWidgetTerms, remoteConfig: ScoresBarWidgetRemoteConfig) {
    super('scoresBarWidget', null, terms, remoteConfig);

    this.prevDaysAmountToBeLink = -7;
    this.nextDaysAmountToBeLink = 30;
  }
}
